import './App.css';
import Quotes from './components/Quotes'
function App() {
  return (
 <Quotes/>
  );
}

export default App;
